import clsx from "clsx";

const InputRadio = ({ label, id, name, register, value, rules, className }) => (
  <div className="flex items-center space-x-2.5">
    <input
      type="radio"
      {...register(name, rules)}
      id={id}
      value={value}
      className={clsx(
        "h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-full bg-white checked:border-2 checked:border-white checked:bg-blue hover:outline hover:outline-1 hover:outline-blue-900",
        className
      )}
    />
    <label htmlFor={id}>{label}</label>
  </div>
);

export default InputRadio;
